import axios from 'axios'
import http from '@/communication/AuthConnection'
import Store from '@/state'

const CancelToken = axios.CancelToken
let source = false

export default async ({ searchText, actualPage = 0, offsetPage = 10 }) => {
  if (source) {
    source.cancel('cancel request')
  }

  source = CancelToken.source()
  const cancelToken = source.token

  const params = {
    actualPage,
    offsetPage,
    searchText,
    sortOrder: Store.getters['ItemAssociation/GET_CONFIG']('sortOrder'),
    filterOnlyWithStock: Store.getters['ItemAssociation/GET_CONFIG']('filterOnlyWithStock')
  }
  try {
    const { data } = await http.get('/v1/stock/paginated-fat-search', { params, cancelToken })
    return data
  } catch (e) {
    return Error(e)
  }
}



// WEBPACK FOOTER //
// ./src/brain/record/stock/SearchProductInStock.js